module.exports = __webpack_public_path__ + "img/new_logo2.b4f0cdfa.png";